import { layoutRoutes } from 'constants/routes'
import MainLayout from 'components/MainLayout/MainLayout'
import NoMatch from 'pages/NoMatch/NoMatch'
import ChatRoomPage from 'pages/Services/CommunityPage/ChatRoomPage/ChatRoomPage'
import ForumPage from 'pages/Services/CommunityPage/ForumPage/ForumPage'
import ForumThreadPage from 'pages/Services/CommunityPage/ForumThreadPage/ForumThreadPage'
import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import CosmicMode from 'components/CosmicMode/CosmicMode'
import ForestMode from 'components/ForestMode/ForestMode'
import OceanMode from 'components/OceanMode/OceanMode'
import GardenMode from 'components/GardenMode/GardenMode'
import DreamMode from 'components/DreamMode/DreamMode'
import PeaceMode from 'components/PeaceMode/PeaceMode'
import SnakeMode from 'components/SnakeMode/SnakeMode'
import ValentineMode from 'components/ValentineMode/ValentineMode'
import ModeSelector from 'components/ModeSelector/ModeSelector'
import { useTheme } from 'contexts/ThemeContext'
import SupportChat from 'components/SupportChat/SupportChat'

console.log = console.warn = console.error = () => { };
console.info = () => { };

function App() {
  const [touchStart, setTouchStart] = useState({ x: 0, y: 0, time: 0 })
  const [touchEnd, setTouchEnd] = useState({ x: 0, y: 0 })
  const [lastTapTime, setLastTapTime] = useState(0)
  const [tapCount, setTapCount] = useState(0)
  const [showLangMenu, setShowLangMenu] = useState(false)
  const [audioContext, setAudioContext] = useState(null)
  const { theme, toggleTheme } = useTheme()

  const [isChatOpen, setIsChatOpen] = useState(false)
  const [isSoundEnabled, setIsSoundEnabled] = useState(() => localStorage.getItem('soundEnabled') !== 'false')
  const [currentMode, setCurrentMode] = useState(() => localStorage.getItem('appMode') || 'cosmic')
  const [showModeSelector, setShowModeSelector] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024)
  const [isMobileMenuExpanded, setIsMobileMenuExpanded] = useState(false)
  const [isSidebarVisible, setIsSidebarVisible] = useState(() => localStorage.getItem('sidebarVisible') !== 'false')

  useEffect(() => {
    localStorage.setItem('sidebarVisible', isSidebarVisible)
  }, [isSidebarVisible])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])



  useEffect(() => {
    const ctx = new (window.AudioContext || window.webkitAudioContext)()
    setAudioContext(ctx)
    return () => ctx.close()
  }, [])

  useEffect(() => {
    localStorage.setItem('soundEnabled', isSoundEnabled)
    if (audioContext) {
      if (isSoundEnabled) audioContext.resume()
      else audioContext.suspend()
    }
  }, [isSoundEnabled, audioContext])


  useEffect(() => {
    localStorage.setItem('appMode', currentMode)
  }, [currentMode])
  useEffect(() => {
    const handleLaunchSnake = () => setCurrentMode('snake')
    window.addEventListener('launchSnakeGame', handleLaunchSnake)
    return () => window.removeEventListener('launchSnakeGame', handleLaunchSnake)
  }, [])
  const handleContextMenu = (event) => {

    event.preventDefault();
  };

  const handleKeyDown = (event) => {
    if (event.code === 'F12') {
      event.preventDefault();
    }
    if (event.ctrlKey && event.shiftKey) {
      if (['KeyC', 'KeyI', 'KeyJ', 'KeyK'].includes(event.code)) {
        event.preventDefault();
      }
    }
    if (event.ctrlKey && event.altKey) {
      if (['KeyC', 'KeyI', 'KeyJ', 'KeyK'].includes(event.code)) {
        event.preventDefault();
      }
    }
    if (event.ctrlKey) {
      if (event.code === 'KeyU') event.preventDefault();
    }
    if (event.metaKey && event.altKey) {
      if (['KeyU', 'KeyC', 'KeyJ', 'KeyK'].includes(event.code)) {
        event.preventDefault();
      }
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  // Listen for mobile plus menu toggle event from MobileBottomNav
  useEffect(() => {
    const handleTogglePlusMenu = () => {
      setIsMobileMenuExpanded(prev => !prev);
    };
    window.addEventListener('toggleMobilePlusMenu', handleTogglePlusMenu);
    return () => {
      window.removeEventListener('toggleMobilePlusMenu', handleTogglePlusMenu);
    };
  }, []);


  const handleTouchStart = (e) => {
    const touch = e.touches[0]
    const currentTime = Date.now()
    const timeSinceLastTap = currentTime - lastTapTime

    if (timeSinceLastTap < 400 && tapCount === 1) {
      e.preventDefault()
    }
    setTouchStart({ x: touch.clientX, y: touch.clientY, time: Date.now() })
  }

  const handleTouchMove = (e) => {
    const touch = e.touches[0]
    const currentTime = Date.now()
    const timeSinceLastTap = currentTime - lastTapTime
    if (timeSinceLastTap < 400 && tapCount === 1) {
      e.preventDefault()
    }
    setTouchEnd({ x: touch.clientX, y: touch.clientY })
  }

  const handleTouchEnd = (e) => {
    const deltaX = touchEnd.x - touchStart.x
    const deltaY = touchEnd.y - touchStart.y
    const deltaTime = Date.now() - touchStart.time


    const isHorizontalSwipe = Math.abs(deltaX) > Math.abs(deltaY) * 2
    const isSwipeFastEnough = deltaTime < 300
    const isSwipeLongEnough = Math.abs(deltaX) > 80

    if (isHorizontalSwipe && isSwipeLongEnough && isSwipeFastEnough) {

      if (deltaX > 0) {
        window.history.back()
      }

      else {
        window.history.forward()
      }
    } else {

      const currentTime = Date.now()
      const timeSinceLastTap = currentTime - lastTapTime
      const isTap = Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10

      if (isTap && timeSinceLastTap < 400 && tapCount === 1) {

        e.preventDefault()
        e.stopPropagation()
        setTapCount(2)

      } else if (isTap) {
        setTapCount(1)
        setLastTapTime(currentTime)
        setTimeout(() => {
          setTapCount(0)
        }, 400)
      }
    }


    setTouchStart({ x: 0, y: 0, time: 0 })
    setTouchEnd({ x: 0, y: 0 })
  }

  const switchLanguage = (lang) => {
    const googleCombo = document.querySelector(".goog-te-combo");
    if (googleCombo) {
      googleCombo.value = lang;
      googleCombo.dispatchEvent(new Event("change"));
    }
    setShowLangMenu(false);
  }

  return (
    <>

      <style>
        {`
          * {
            -webkit-tap-highlight-color: transparent;
          }
           @keyframes hintFadeIn {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          @media (max-width: 1024px) {
            * {
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              -webkit-touch-callout: none;
            }
            input, textarea, [contenteditable] {
              -webkit-user-select: text !important;
              -moz-user-select: text !important;
              -ms-user-select: text !important;
              user-select: text !important;
            }
          }
        `}
      </style>

      {currentMode === 'cosmic' && <CosmicMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'forest' && <ForestMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'ocean' && <OceanMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'garden' && <GardenMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'dream' && <DreamMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'peace' && <PeaceMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}
      {currentMode === 'snake' && <SnakeMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} onExit={() => setCurrentMode('cosmic')} />}
      {currentMode === 'valentine' && <ValentineMode audioContext={audioContext} isSoundEnabled={isSoundEnabled} />}

      {/* Restore sidebar button — bottom center, desktop only, when hidden */}
      {!isMobile && !isSidebarVisible && (
        <div
          onClick={() => setIsSidebarVisible(true)}
          title="Показать меню"
          style={{
            position: 'fixed',
            bottom: '24px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '12px 24px',
            borderRadius: '24px',
            background: 'rgba(20, 20, 30, 0.85)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(255,255,255,0.15)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            cursor: 'pointer',
            zIndex: 10004,
            boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
            transition: 'transform 0.2s',
            color: 'rgba(255,255,255,0.85)',
            fontSize: '14px',
            fontWeight: '500'
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateX(-50%) translateY(-2px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateX(-50%) translateY(0)'}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
          <span>Показать меню</span>
        </div>
      )}

      {(isMobile || isSidebarVisible) && <div style={{
        position: 'fixed',
        bottom: isMobile ? '114px' : '20px',  // Position above mobile nav
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10002,
        display: isMobile && !isMobileMenuExpanded ? 'none' : 'flex',  // Hide on mobile unless expanded
        flexDirection: 'row',
        gap: '12px',
        background: 'rgba(20, 20, 30, 0.7)',
        backdropFilter: 'blur(20px)',
        padding: '12px',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
        alignItems: 'center',
        maxWidth: 'calc(100vw - 40px)'
      }}>

        {/* Mobile Toggle Button - Removed, now in MobileBottomNav */}

        {/* Controls Container */}
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px',
          visibility: isMobile && !isMobileMenuExpanded ? 'hidden' : 'visible',
          opacity: isMobile && !isMobileMenuExpanded ? 0 : 1,
          transform: isMobile && !isMobileMenuExpanded ? 'translateY(10px) scale(0.9)' : 'translateY(0) scale(1)',
          transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
          pointerEvents: isMobile && !isMobileMenuExpanded ? 'none' : 'auto'
        }}>

          {/* 1. Info Button (Desktop Only) */}
          {!isMobile && (
            <div style={{ position: 'relative' }}>
              <div
                onClick={() => setTapCount(tapCount === -1 ? 0 : -1)}
                style={{
                  width: '42px', height: '42px',
                  borderRadius: '50%',
                  background: tapCount === -1 ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  cursor: 'pointer', transition: 'all 0.2s ease',
                  color: 'white'
                }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
                onMouseLeave={e => e.currentTarget.style.background = tapCount === -1 ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)'}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12.01" y2="8"></line>
                </svg>
              </div>


              {tapCount === -1 && (
                <div style={{
                  position: 'absolute',
                  bottom: '0',
                  right: 'calc(100% + 20px)',
                  width: '280px',
                  background: 'linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(50, 40, 80, 0.98))',
                  backdropFilter: 'blur(24px)',
                  borderRadius: '20px',
                  padding: '24px',
                  border: '1px solid rgba(150, 100, 255, 0.2)',
                  boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
                  animation: 'hintFadeIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                  zIndex: 10003,
                  pointerEvents: 'none',
                  textAlign: 'left'
                }}>
                  <div style={{
                    color: '#fff', fontSize: '14px', fontWeight: '700', marginBottom: '16px',
                    borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '12px',
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    textTransform: 'uppercase', letterSpacing: '1px'
                  }}>
                    <span>Управление</span>
                    <span style={{ fontSize: '10px', opacity: 0.5 }}>INFO</span>
                  </div>
                  {(() => {
                    const modeInfo = {
                      cosmic: { color: '#bf80ff', items: [['Туманность', 'ЛКМ'], ['Создать звезду', 'ПКМ'], ['Черная дыра', 'ПКМ×2'], ['Кольца', 'WHEEL']] },
                      forest: { color: '#80ffbf', items: [['Посадить дерево', 'ЛКМ'], ['Светлячки', 'ПКМ'], ['Молния', 'ПКМ×2'], ['Ветер/Дождь', 'WHEEL']] },
                      ocean: { color: '#38bdf8', items: [['Косяк рыб', 'ЛКМ'], ['Пузырьки', 'ПКМ'], ['Биосвечение', 'ПКМ×2'], ['Течение', 'WHEEL']] },
                      garden: { color: '#f9a8d4', items: [['Бабочки', 'ЛКМ'], ['Цветок', 'ПКМ'], ['Солнечный луч', 'ПКМ×2'], ['Дождь', 'WHEEL']] },
                      dream: { color: '#818cf8', items: [['Звёздочки', 'ЛКМ'], ['Облако', 'ПКМ'], ['Падающая звезда', 'ПКМ×2'], ['Луна', 'WHEEL']] },
                      peace: { color: '#fda4af', items: [['Сердечки', 'ЛКМ'], ['Птички', 'ПКМ'], ['Радуга', 'ПКМ×2'], ['Ветерок', 'WHEEL']] },
                      snake: { color: '#4ade80', items: [['Мышь — руль змейки', '🖱'], ['Собирай точки', 'DOT'], ['Избегай себя', '⚠'], ['Скорость растёт', '↑']] },
                      valentine: { color: '#fb7185', items: [['Письма', 'ЛКМ'], ['Сердечки', 'ПКМ'], ['Валентинка', 'ПКМ×2'], ['Волна любви', 'WHEEL']] },
                    };
                    const info = modeInfo[currentMode] || modeInfo.cosmic;
                    return (
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '13px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {info.items.map(([label, key]) => (
                          <li key={label} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ color: 'rgba(255,255,255,0.7)' }}>{label}</span>
                            <span style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', color: info.color }}>{key}</span>
                          </li>
                        ))}
                      </ul>
                    );
                  })()}
                </div>
              )}
            </div>
          )}

          {/* 1.5 Support Chat Button */}
          <div
            onClick={() => {
              setIsChatOpen(!isChatOpen);
              setShowModeSelector(false);
              if (isMobile) setIsMobileMenuExpanded(false);
            }}
            title="Чат поддержки"
            style={{
              width: '42px', height: '42px',
              borderRadius: '50%',
              background: isChatOpen
                ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                : 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', transition: 'all 0.2s ease',
              boxShadow: isChatOpen ? '0 0 15px rgba(118, 75, 162, 0.5)' : 'none'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'scale(1.1)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z" fill={isChatOpen ? 'white' : 'rgba(255,255,255,0.8)'} />
              <path d="M11 14H13V12H11V14ZM11 10H13V6H11V10Z" fill={isChatOpen ? 'white' : 'rgba(255,255,255,0.8)'} />
            </svg>
          </div>


          {!isMobile && (
            <div
              onClick={() => setShowModeSelector(prev => !prev)}
              title="Выбор режима"
              style={{
                width: '42px', height: '42px',
                borderRadius: '50%',
                background: showModeSelector
                  ? 'rgba(255,255,255,0.15)'
                  : 'rgba(255,255,255,0.06)',
                border: `1px solid ${showModeSelector ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.15)'}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease',
                boxShadow: showModeSelector ? '0 4px 20px rgba(0,0,0,0.4)' : '0 4px 12px rgba(0,0,0,0.2)',
                fontSize: '20px', position: 'relative', zIndex: 99995
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.borderColor = showModeSelector ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.15)';
              }}
            >
              {currentMode === 'cosmic' && '✨'}
              {currentMode === 'forest' && '🌲'}
              {currentMode === 'ocean' && '🌊'}
              {currentMode === 'garden' && '🌸'}
              {currentMode === 'dream' && '🌌'}
              {currentMode === 'peace' && '🕊️'}
              {currentMode === 'snake' && '🐍'}
              {currentMode === 'valentine' && '💌'}
              <ModeSelector
                isOpen={showModeSelector}
                currentMode={currentMode}
                onSelect={(m) => { setCurrentMode(m); setShowModeSelector(false); }}
                onClose={() => setShowModeSelector(false)}
              />
            </div>
          )}


          {/* Sound Button (Desktop Only) */}
          {!isMobile && (
            <div
              onClick={() => setIsSoundEnabled(!isSoundEnabled)}
              title={isSoundEnabled ? 'Выключить звук' : 'Включить звук'}
              style={{
                width: '42px', height: '42px',
                borderRadius: '50%',
                background: isSoundEnabled
                  ? 'linear-gradient(135deg, rgba(80, 220, 100, 0.3), rgba(40, 180, 80, 0.3))'
                  : 'rgba(255, 255, 255, 0.05)',
                border: isSoundEnabled ? '1px solid rgba(100, 255, 120, 0.4)' : '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease'
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.1)';
                e.currentTarget.style.background = isSoundEnabled ? 'linear-gradient(135deg, rgba(80, 220, 100, 0.4), rgba(40, 180, 80, 0.4))' : 'rgba(255, 255, 255, 0.15)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.background = isSoundEnabled ? 'linear-gradient(135deg, rgba(80, 220, 100, 0.3), rgba(40, 180, 80, 0.3))' : 'rgba(255, 255, 255, 0.05)';
              }}
            >
              {isSoundEnabled ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                  <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                  <line x1="23" y1="9" x2="17" y2="15"></line>
                  <line x1="17" y1="9" x2="23" y2="15"></line>
                </svg>
              )}
            </div>
          )}

          {/* 4. Theme Toggle */}
          <div
            onClick={toggleTheme}
            title={theme === 'dark' ? 'Светлая тема' : 'Темная тема'}
            style={{
              width: '42px', height: '42px',
              borderRadius: '50%',
              background: theme === 'light'
                ? 'linear-gradient(135deg, rgba(255, 200, 80, 0.3), rgba(255, 160, 40, 0.3))'
                : 'rgba(255, 255, 255, 0.05)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', transition: 'all 0.2s ease',
              color: 'white'
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'scale(1.1)';
              e.currentTarget.style.background = theme === 'light' ? 'linear-gradient(135deg, rgba(255, 200, 80, 0.4), rgba(255, 160, 40, 0.4))' : 'rgba(255, 255, 255, 0.2)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.background = theme === 'light' ? 'linear-gradient(135deg, rgba(255, 200, 80, 0.3), rgba(255, 160, 40, 0.3))' : 'rgba(255, 255, 255, 0.05)';
            }}
          >
            {theme === 'light' ? (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            ) : (
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
            )}
          </div>


          <div style={{ position: 'relative' }}>
            <div
              onClick={() => setShowLangMenu(!showLangMenu)}
              title="Сменить язык / Change Language"
              style={{
                width: '42px', height: '42px',
                borderRadius: '50%',
                background: showLangMenu ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease',
                color: 'white'
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)'}
              onMouseLeave={e => e.currentTarget.style.background = showLangMenu ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)'}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
              </svg>
            </div>


            {showLangMenu && (
              <div style={{
                position: 'absolute',
                top: '50%',
                right: 'calc(100% + 20px)',
                transform: 'translateY(-50%)',
                width: '180px',
                background: 'linear-gradient(135deg, rgba(30, 30, 40, 0.98), rgba(50, 40, 80, 0.98))',
                backdropFilter: 'blur(24px)',
                borderRadius: '16px',
                padding: '12px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
                display: 'flex', flexDirection: 'column', gap: '4px',
                maxHeight: '400px', overflowY: 'auto',
                zIndex: 10003
              }}>
                <div style={{
                  color: '#fff', fontSize: '12px', fontWeight: '700', marginBottom: '8px',
                  borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px',
                  textTransform: 'uppercase', letterSpacing: '1px', paddingLeft: '4px'
                }}>
                  Язык / Language
                </div>
                {[
                  { code: 'ky', label: 'Кыргызча' },
                  { code: 'ru', label: 'Русский' },
                  { code: 'uz', label: 'Oʻzbekcha' },
                  { code: 'en', label: 'English' },
                  { code: 'tr', label: 'Türkçe' },
                  { code: 'kk', label: 'Қазақша' },
                  { code: 'hi', label: 'हिन्दी' },
                  { code: 'ur', label: 'اردو' }
                ].map(lang => (
                  <div
                    key={lang.code}
                    onClick={() => switchLanguage(lang.code)}
                    style={{
                      padding: '10px 12px',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      color: 'rgba(255,255,255,0.8)',
                      fontSize: '14px',
                      transition: 'background 0.2s',
                      display: 'flex', alignItems: 'center', gap: '10px'
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                      e.currentTarget.style.color = '#fff';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
                    }}
                  >
                    <span style={{
                      textTransform: 'uppercase', fontSize: '10px',
                      background: 'rgba(255,255,255,0.1)', padding: '2px 4px', borderRadius: '4px',
                      width: '24px', textAlign: 'center'
                    }}>{lang.code}</span>
                    {lang.label}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Hide sidebar button — desktop only */}
          {!isMobile && (
            <div
              onClick={() => setIsSidebarVisible(false)}
              title="Скрыть меню"
              style={{
                width: '42px', height: '42px',
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid rgba(255,255,255,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', transition: 'all 0.2s ease',
                color: 'rgba(255,255,255,0.5)',
                marginTop: '4px'
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </div>
          )}

        </div> {/* Closing Controls Container */}
      </div>}

      <div
        className="app"
        data-theme={theme}
        onContextMenu={handleContextMenu}


        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}

        style={{
          background: theme === 'light'
            ? 'linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%)'
            : '#111111',
          minHeight: '100vh'
        }}
      >
        <div>
          <Routes>
            <Route element={<MainLayout />}>
              {layoutRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={route.component}
                />
              ))}
            </Route>
            <Route path="/services/community/chat/:roomSlug" element={<ChatRoomPage />} />
            <Route path="/services/community/forum/:forumId" element={<ForumPage />} />
            <Route path="/services/community/forum/:forumId/thread/:threadId" element={<ForumThreadPage />} />
            <Route path="*" element={<NoMatch />} />
          </Routes>
        </div>

        <SupportChat isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
      </div>
    </>
  )
}

export default App
